export const COLLAPSE_DIRECTIVE_LOCALE_ZHCHT = {
    expand: 'å±é',
    fold: 'æ¶èµ·'
};
